export const ADD_TODO = "ADD_TODO";
export const TOGGLE_TODO = "TOGGLE_TODO";
export const SET_FILTER = "SET_FILTER";

export const UPDATE_THEME = "UPDATE_THEME";
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";
